module.exports = __webpack_public_path__ + "static/UNL-8519603989967360e8282f17d25f9861.woff2";